// Catalog of pages that an Admin can grant to a TeamLeader.
// Keep in sync with the `routes` array in SideBar.jsx (admin menu).
// Used by Users.jsx (permission picker) and SideBar.jsx (menu filter).
//
// Grouped by sidebar section so the Permissions drawer is easy to scan.
export const TEAM_LEADER_PAGES = [
  // Top level
  { path: '/', label: 'Dashboard', group: 'Main' },
  { path: '/Realtime', label: 'Realtime', group: 'Main' },
  { path: '/Users', label: 'Agents', group: 'Main' },

  // Campaign
  { path: '/AddCampaign', label: 'Add Campaign', group: 'Campaign' },
  { path: '/Makegui', label: 'Make CRM', group: 'Campaign' },
  { path: '/Assignlist', label: 'Assign List', group: 'Campaign' },
  { path: '/Assignagent', label: 'Assign Agent', group: 'Campaign' },
  { path: '/CampDid', label: 'Camp DID', group: 'Campaign' },
  { path: '/AddDisposition', label: 'Disposition', group: 'Campaign' },
  { path: '/ChurnLeads', label: 'Churn Leads', group: 'Campaign' },

  // Reports
  { path: '/Reportlive', label: 'Live Report', group: 'Reports' },
  { path: '/Report', label: 'All Reports', group: 'Reports' },
  { path: '/FilterReport', label: 'Filter Report', group: 'Reports' },
  { path: '/FilterReportold', label: 'Filter Report (Old)', group: 'Reports' },
  { path: '/Agentlog', label: 'Agent Log', group: 'Reports' },
  { path: '/AgentPerformance', label: 'Agent Performance', group: 'Reports' },
  { path: '/BreakReport', label: 'Break Report', group: 'Reports' },
  { path: '/Callbackreport', label: 'Callback Report', group: 'Reports' },

  // Settings
  { path: '/settings', label: 'Settings', group: 'Settings' },
  { path: '/UploadAudio', label: 'Upload Audio', group: 'Campaign' },
  { path: '/MusicOnHold', label: 'Music On Hold', group: 'Campaign' },
  { path: '/UploadNumber', label: 'Upload Number', group: 'Campaign' },
  { path: '/BlockNumber', label: 'Block Number', group: 'Settings' },
  { path: '/ChangePwd', label: 'Password Change', group: 'Settings' },
  { path: '/AllowIP', label: 'Allow IP', group: 'Settings' },
  { path: '/Break', label: 'Break Setting', group: 'Settings' },
  { path: '/TransferNumber', label: 'Transfer Number', group: 'Settings' },

  // SMS Suits
  { path: '/Smssuits', label: 'SMS Suits', group: 'SMS' },
  { path: '/SmsportSetting', label: 'SMS Port Setting', group: 'SMS' },

  // IVR
  { path: '/AddAgent',      label: 'IVR Agent',  group: 'IVR' },
  { path: '/DrawIvr',       label: 'Draw IVR',   group: 'IVR' },
  { path: '/Group',         label: 'IVR Group',  group: 'IVR' },
  { path: '/IvrGroupAssignAgent', label: 'IVR Group — Assign Agent', group: 'IVR' },
  { path: '/IvrReport', label: 'IVR Report', group: 'IVR' },

  // Skills (read + own-subtree agent assignment only — backend gates writes)
  { path: '/Skills', label: 'Skills', group: 'Users' },
];

export const parsePermissions = (csv) => {
  if (!csv) return [];
  return String(csv)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

export const serializePermissions = (arr) => (arr || []).filter(Boolean).join(',');
